import axios from "axios";
import crudApi from "./crudApi";
import {API_LOTS, API_MASS_UPDATE_LOTS, API_MASS_UPDATE_LOTS_TO_DELIVER_AT} from '../api.js';

class Lot extends crudApi {
    async getContainerTotalsBySpecyAndSize(options = {}) {
        return await axios.get(`${API_LOTS}/container_totals_by_specy_and_size`, options);
    }

    async create(data, options = {}) {
        return await axios.post(API_LOTS, data, options);
    }

    get(id, options = {}) {
        return axios.get(`${API_LOTS}/${id}`, options);
    }

    async edit(data, options = {}) {
        return await axios.patch(`${API_LOTS}/${data.id}`, data, options);
    }

    async massUpdateStatusAndDeliveryPoint(data, options = {}) {
        return await axios.post(API_MASS_UPDATE_LOTS, data, options);
    }

    async massUpdateToDeliverAt(data, options = {}) {
        return await axios.post(API_MASS_UPDATE_LOTS_TO_DELIVER_AT, data, options);
    }
    async getCsv( options = {}) {
        return await axios.get(`${API_LOTS}/csv`, options);
    }

    async getLotCsv( id, options = {}) {
        return await axios.get(`${API_LOTS}/lot_csv/${id}`, options);
    }

    async getLotQrCode( id, options = {}) {
        return await axios.get(`${API_LOTS}/lot_qr_code/${id}`, options);
    }

    async getLotsQrCodeRapport( options = {}) {
        return await axios.get(`${API_LOTS}/lots_qr_code_rapport`, options);
    }
};

export default new Lot(API_LOTS);